import MenuHeader from "../components/menu_header";
import { connect } from 'react-redux';

export default connect()(MenuHeader);
